import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  concatenateTravelerNames,
  filterFlightsByCondition,
  filterTravelersByCondition,
  isEmptyArray,
  isEmptyObject,
  isStringEmpty,
  notEqual,
  parseEmptyArray,
} from '@common/helpers';
import { FLIGHT_STATUS_CODE } from '@common/helpers/constants/my-booking/my_booking_service.contant';
import {
  CHARGEABLE_LOUNGE_TYPE,
  NOTELIGIBLEFORPAYMENT,
  PaymentMethodsType,
} from '@common/helpers/constants/service-request-payment-input/service-request-payment-input.constants';
import {
  MListData,
  PREVIOUS_PAGE_IDENTIFIER,
  PassengerType,
  ServicingCommonModel,
  ServicingFunctionIdType,
  ServicingPageIdType,
} from '@common/interfaces';
import { CountryI18nBy2LetterCode } from '@common/interfaces/master/country_i18n_by2lettercode';
import { CountryI18nPosCountry } from '@common/interfaces/master/country_i18n_pos_country';
import { MChargeableService } from '@common/interfaces/master/m_chargeable_service';
import { MChargeableServiceSsr } from '@common/interfaces/master/m_chargeable_service_ssr';
import { MPaymentError } from '@common/interfaces/master/m_payment_error';
import { MPaymentInformation } from '@common/interfaces/master/m_payment_information';
import { MOfficeByOffceCode } from '@common/interfaces/master/office_by offce_code';
import { PosCountryAll } from '@common/interfaces/master/pos_county_all';
import {
  ChargeableLoungePassengerApplyInfo,
  ChargeableLoungePassengerApplyStatusMap,
  FirstBaggageBoundMap,
  FirstBaggagePassengerApplyInfo,
  MealPassengerApplyInfo,
  MealPassengerApplyStatusMap,
} from '@common/interfaces/mybooking/mybooking.interface';
import { FirstBaggagePassengerMap, FirstBaggagePnr } from '@common/interfaces/mybooking/order-baggage.interface';
import { Lounge, Meal } from '@common/interfaces/mybooking/order-services.interface';
import {
  PaymentDetailsData,
  PurchasedServiceInformationData,
} from '@common/interfaces/reservation-basic-information-input/reservation-basic-information-input.interface';
import { SegmentMap } from '@common/interfaces/servicing-seatmap/seat-reservation-status';
import { LOAD_MASTERS } from '@common/master/master';
import { ServicingCommonStoreService } from '@common/services';
import { CardinalService } from '@common/services/service-request-payment-input/cardinal.service';
import { ServiceRequestPaymentInputService } from '@common/services/service-request-payment-input/service-request-payment-input-service';
import { SupportPageComponent } from '@lib/components/support-class';
import {
  ApiCommonRequest,
  DeviceType,
  ErrorType,
  LoginStatusType,
  MPropertyType,
  PageType,
  ReplaceParam,
} from '@lib/interfaces';
import { StaticMsgPipe } from '@lib/pipes';
import {
  AswCommonStoreService,
  AswMasterService,
  CommonLibService,
  LoadScriptService,
  PageInitService,
} from '@lib/services';
import { AswCommonState } from '@lib/store';
import { BehaviorSubject, Observable, Subscription, combineLatest, forkJoin, take } from 'rxjs';
import {
  AmcmemberApiService,
  GetBasicReservationInformationRequest,
  GetBasicReservationInformationResponseData,
} from 'src/sdk-amcmember';
import { Bound, GetOrderRequest, DefaultService as ServicingApiService, Traveler, Type1 } from 'src/sdk-servicing';
import { ServiceRequestPaymentInputPresComponent } from '../presenter/service-request-payment-input-pres.component';
import { ErrorCodeConstants } from '@conf/app.constants';

@Component({
  selector: 'asw-service-request-payment-input-cont',
  templateUrl: './service-request-payment-input-cont.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [Title],
})
export class ServiceRequestPaymentInputContComponent extends SupportPageComponent implements OnInit {
  // 画面ID
  pageId: string = ServicingPageIdType.SERVICE_REQUEST_PAYMENT_INPUT;
  // 機能ID
  functionId: string = ServicingFunctionIdType.SERVICE_REQUEST;
  override autoInitEnd: boolean = false;
  _subscriptions: Subscription = new Subscription();

  public isChangePaymentMethod = true;

  public isChangeCreditCard = true;

  private selectedPaymentMethod: string = '';

  public property!: MPropertyType;

  public isPaying = false;

  servicingCommon!: ServicingCommonModel;
  deviceId: string = '';

  flights: Array<Type1> = [];
  aswCommon!: AswCommonState;
  isGetMiscDataCompleted$ = new BehaviorSubject<boolean>(false);
  isApiGetOrderCallCompleted$ = new BehaviorSubject<boolean>(false);
  isApiAmcMemberCallCompleted$ = new BehaviorSubject<boolean>(false);
  isServicingCommonUpdateCompleted$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly _common: CommonLibService,
    private readonly _pageInitService: PageInitService,
    private readonly _aswCommonStoreService: AswCommonStoreService,
    private readonly _serviceRequestPaymentInputService: ServiceRequestPaymentInputService,
    private readonly _aswMasterService: AswMasterService,
    @Inject(DOCUMENT) private readonly _document: Document,
    private readonly _servicingCommonStoreService: ServicingCommonStoreService,
    private readonly _servicingApiService: ServicingApiService,

    private readonly _amcmemberApiService: AmcmemberApiService,
    private readonly _titleService: Title,
    private readonly _staticMsg: StaticMsgPipe,
    private _changeDetectorRef: ChangeDetectorRef,
    private readonly _cardinalService: CardinalService,
    private _loadScriptSvc: LoadScriptService
  ) {
    // (1.1) 画面の初期化処理(G01-003)の初期化開始処理を呼び出す。
    super(_common, _pageInitService);
  }

  // PresenterのコンポーネントのViewChild
  @ViewChild(ServiceRequestPaymentInputPresComponent) presenterComponent!: ServiceRequestPaymentInputPresComponent;

  init() {
    this.onInit();
  }

  onInit() {
    this._subscriptions.add(
      forkJoin([
        this._servicingCommonStoreService.getServicingCommonModel$().pipe(take(1)),
        this._aswCommonStoreService.getPagefuncId$(PageType.PAGE).pipe(take(1)),
        this._aswMasterService.load(
          [
            LOAD_MASTERS.M_PAYMENT_INFORMATION,
            LOAD_MASTERS.M_PAYMENT_ERROR,
            LOAD_MASTERS.COUNTRY_I18N_BY_2LETTERCODE,
            LOAD_MASTERS.POS_COUNTRY_ALL,
            LOAD_MASTERS.LISTDATA_ALL,
            LOAD_MASTERS.CHARGEABLE_SERVICE_ALL,
            LOAD_MASTERS.CHARGEABLE_SERVICE_SSR_ALL,
            LOAD_MASTERS.OFFICE_BY_OFFICE_CODE,
            LOAD_MASTERS.COUNTRY_I18N_POS_COUNTRY,
          ],
          true
        ) as Observable<
          [
            MPaymentInformation[],
            MPaymentError[],
            CountryI18nBy2LetterCode[],
            PosCountryAll[],
            MListData[],
            MChargeableService[],
            MChargeableServiceSsr[],
            MOfficeByOffceCode,
            CountryI18nPosCountry[]
          ]
        >,
      ]).subscribe((response) => {
        const [
          servicingCommon,
          aswCommon,
          [
            mPaymentInformation,
            mPaymentError,
            countryI18nBy2LetterCode,
            posCountryAll,
            mListData,
            mChargeableService,
            mChargeableServiceSsr,
            officeByOffceCodeInfo,
            countryI18nPosCountry,
          ],
        ] = response as [
          ServicingCommonModel,
          AswCommonState,
          [
            MPaymentInformation[],
            MPaymentError[],
            CountryI18nBy2LetterCode[],
            PosCountryAll[],
            MListData[],
            MChargeableService[],
            MChargeableServiceSsr[],
            MOfficeByOffceCode,
            CountryI18nPosCountry[]
          ]
        ];
        // (1.6.3) オフィス

        this.servicingCommon = servicingCommon;
        this.aswCommon = aswCommon;
        this._serviceRequestPaymentInputService.serviceRequestPaymentInputMasterState$.next({
          paymentInformation: parseEmptyArray(mPaymentInformation),
          paymentErrors: parseEmptyArray(mPaymentError),
          countryI18nBy2LetterCodes: Object.values(countryI18nBy2LetterCode).map((value: any) => value?.[0]),
          posCountryAll: Object.values(posCountryAll).map((value: any) => value?.[0]),
          listData: parseEmptyArray(mListData),
          officeByOffceCodeInfo: officeByOffceCodeInfo,
          chargeableService: parseEmptyArray(mChargeableService),
          chargeableServiceSsr: parseEmptyArray(mChargeableServiceSsr),
          countryI18nPosCountries: parseEmptyArray(countryI18nPosCountry),
        });

        this.isGetMiscDataCompleted$.next(true);
      })
    );

    // (1.4)	PNR情報取得APIを呼び出す。
    const getOrderRequest: GetOrderRequest = this.createGetOrderRequest();
    this._subscriptions.add(
      this._servicingApiService.ordersGetOrderPost(getOrderRequest).subscribe({
        next: (response) => {
          this._serviceRequestPaymentInputService.pnr$.next(response?.data ?? {});
          this.isApiGetOrderCallCompleted$.next(true);
        },
        error: (error) => {
          // (1.4.2) レスポンス情報
          this.handleGetOrderError('E0400', ErrorCodeConstants.ERROR_CODES.EBAZ000159);
        },
      })
    );

    //  (1.5)  ユーザ共通情報.ログインステータス= "REAL_LOGIN"(リアルログイン)の場合、予約基本情報取得を行う。
    if (this._common.aswContextStoreService.aswContextData.loginStatus === LoginStatusType.REAL_LOGIN) {
      const param: ApiCommonRequest & GetBasicReservationInformationRequest = {
        commonIgnoreErrorFlg: true,
      };
      this._subscriptions.add(
        this._amcmemberApiService.getBasicReservationInformationPost(param).subscribe({
          // (1.5.2) レスポンス情報
          next: (response) => {
            // (1.5.2.1) 正常終了の場合
            // (1.5.2.1.1) 取得した予約基本情報取得API応答を保持する。
            this._serviceRequestPaymentInputService.amc$.next(
              response.data ?? ({} as GetBasicReservationInformationResponseData)
            );
            this.isApiAmcMemberCallCompleted$.next(true);
          },
          error: (error) => {
            // (1.5.2.2) 異常終了の場合
            // (1.5.2.2.1) 以降の処理を続行する。
            this.isApiAmcMemberCallCompleted$.next(true);
          },
        })
      );
    }

    this._subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((response) => {
        this.servicingCommon = response;
        this.isServicingCommonUpdateCompleted$.next(true);
      })
    );

    this._subscriptions.add(
      combineLatest([
        this.isGetMiscDataCompleted$,
        this.isApiGetOrderCallCompleted$,
        this.isServicingCommonUpdateCompleted$,
      ]).subscribe(([a, b, c]) => {
        if (a && b && c) {
          this.runInit();
          this.initialDisplayProcessing();
          this._serviceRequestPaymentInputService.dynamicSubject.next({
            aswContext: this._common.aswContextStoreService.aswContextData,
            getOrderReply: {
              data: this._serviceRequestPaymentInputService.pnr$.value,
            },
            pageContext: {
              currentPaymentMethod: this._serviceRequestPaymentInputService.paymentMethod$.value,
            },
          });
          this._pageInitService.endInit(this._serviceRequestPaymentInputService.dynamicSubject.asObservable());
        }
      })
    );

    this._subscriptions.add(
      this._cardinalService.getPayingStatus$().subscribe((status: boolean) => {
        this.isPaying = status;
        this._changeDetectorRef.markForCheck();
      })
    );
  }

  isNhGroupAndArrivalUs() {
    return this.flights?.some(
      // 7.2.1.	PNR情報取得API応答.data.air.bounds.flightsの中に、isNhGroupOperated = true、かつ　arrival.country2letterCode = "US"である情報が存在する場合
      // 7.2.1.1.	NHグループ運航でアメリカ行き便有無にtrueを設定する。
      // 7.2.2.	上記以外の場合、NHグループ運航でアメリカ行き便有無にfalseを設定する。
      (flight) => flight.isNhGroupOperated === true && flight.arrival?.country2letterCode === 'US'
    );
  }

  runInit() {
    // (1.2) 遷移元が画面情報.機能ID≠"S02"、または画面情報.画面ID≠"P020"の場合、直近の遷移元画面情報を保存するため以下に値を設定する。
    const currentPage = this.functionId + '-' + this.pageId;
    const previousPage = `${this.aswCommon.functionId ?? ''}-${this.aswCommon.pageId ?? ''}`;

    if (currentPage !== previousPage) {
      this._serviceRequestPaymentInputService.transitionSourceFullFunctionPageId = previousPage;
      this._serviceRequestPaymentInputService.transitionSourceFunctionId = this.aswCommon.functionId ?? '';
      this._serviceRequestPaymentInputService.transitionSourcePageId = this.aswCommon.pageId ?? '';
    }
    // (1.3) 画面情報に以下の内容を設定する。
    this.setInitialAswCommon();
    this.setPageTitle();
  }

  /** (1.3) 画面情報に以下の内容を設定する。*/
  setInitialAswCommon() {
    this._common.aswCommonStoreService.updateAswCommon({
      functionId: this.functionId,
      pageId: this.pageId,
      subFunctionId: '',
      subPageId: '',
      isEnabledLogin: false,
      isUpgrade: false,
    });
  }

  setPageTitle() {
    // 画面タイトルの静的文言キー
    // "label.purchaseInformation"(Ancillary支払情報入力)
    // ※画面タイトルには共通ページタイトル(label.aswPageTitle)を含む。
    const title = `${this._staticMsg.transform('label.purchaseInformation')}${this._staticMsg.transform(
      'label.aswPageTitle'
    )}`;
    this._titleService.setTitle(title);
  }

  // (1.8) reputationManagerを利用したdeviceID取得のため、以下のスクリプトパラメータを設定しsnare.jsをインクルードする。
  reputationManagerInstall() {
    const snareUrl = this._aswMasterService.getMPropertyByKey('paymentInformationInput', 'reputationManager.snareUrl');
    // (1.8.1) 以下の条件でASWDBの「プロパティ」テーブルからプロパティ.valueを取得し、実IP情報収集利用フラグとして保持する。
    const io_enable_rip = this._aswMasterService.getMPropertyByKey(
      'paymentInformationInput',
      'reputationManager.ioEnableRip'
    );
    // (1.8.2) 以下の条件でASWDBの「プロパティ」テーブルからプロパティ.valueを取得し、Flash8インストール判定フラグとして保持する。
    const io_install_flash = this._aswMasterService.getMPropertyByKey(
      'paymentInformationInput',
      'reputationManager.ioInstallFlash'
    );
    // (1.8.3) 以下の条件でASWDBの「プロパティ」テーブルからプロパティ.valueを取得し、Active X controlインストール判定フラグとして保持する。
    const io_install_stm = this._aswMasterService.getMPropertyByKey(
      'paymentInformationInput',
      'reputationManager.ioInstallStm'
    );
    // (1.8.4) 以下の条件でASWDBの「プロパティ」テーブルからプロパティ.valueを取得し、ActiveXIE最低ブラウザバージョンとして保持する。
    const io_exclude_stm = this._aswMasterService.getMPropertyByKey(
      'paymentInformationInput',
      'reputationManager.ioExcludeStm'
    );
    // (1.8.5) snare.jsの読み込みの前にスクリプトのパラメータのコンフィグレーションを先に行う。
    const _window = window as any;
    _window.io_bbout_element_id = 'blackBox';
    _window.io_enable_rip = io_enable_rip;
    _window.io_install_flash = io_install_flash;
    _window.io_install_stm = io_install_stm;
    _window.io_exclude_stm = io_exclude_stm;
    _window.io_bb_callback = (bb: any, complete: any) => {
      if (complete) {
        this.deviceId = bb;
      }
    };

    this._loadScriptSvc.load$(snareUrl, true).subscribe();
  }

  createGetOrderRequest(): GetOrderRequest {
    const aswService = this._common.aswServiceStoreService.aswServiceData ?? {};
    const request = {
      credential: {
        firstName: aswService.firstName!,
        lastName: aswService.lastName!,
      },
      mask: false,
      getServiceCatalogue: true,
      sendReservationInformation: false,
    };
    return {
      ...(aswService?.orderId &&
        !aswService?.travelDocumentId && {
          orderId: aswService?.orderId,
        }),
      ...(aswService?.travelDocumentId && {
        travelDocumentId: aswService?.travelDocumentId,
      }),
      ...request,
    };
  }

  handleGetOrderError(
    errorMsgId?: string,
    apiErrorCode?: string,
    params?: ReplaceParam | ReplaceParam[],
    routingPath?: string,
    isPopupPage?: boolean
  ) {
    this._common.errorsHandlerService.setNotRetryableError({
      errorType: ErrorType.BUSINESS_LOGIC,
      ...(apiErrorCode != undefined && { apiErrorCode }),
      ...(errorMsgId != undefined && { errorMsgId }),
      ...(routingPath != undefined && { routingPath }),
      ...(isPopupPage != undefined && { isPopupPage }),
      ...(params != undefined && { params }),
    });
    this._pageInitService.endInit(this.params);
  }

  initialDisplayProcessing() {
    this.flights =
      this._serviceRequestPaymentInputService.pnr$?.value?.air?.bounds?.flatMap(
        (bound: Bound) => bound.flights ?? ([] as Type1[])
      ) ?? ([] as Type1[]);
    // (1.6)	支払方法選択の初期化処理
    this.initPaymentMethod();
    // (1.7) 変数を作成する。
    // (1.7.1) パスワード認証実施済み判定をfalse初期化する。
    this._serviceRequestPaymentInputService.isPasswordAuthenticationCompleted = false;
    // (1.7.2) NHグループ運航でアメリカ行き便有無を設定する。
    this._serviceRequestPaymentInputService.isNhGroupOperatedAndArrivalUs = this.isNhGroupAndArrivalUs();
    // (1.8) reputationManagerを利用したdeviceID取得のため、以下のスクリプトパラメータを設定しsnare.jsをインクルードする。
    this.reputationManagerInstall();
    // (1.9) 支払詳細のデータを用意する。
    this.preparePaymentDetailsData();
    // (1.10) SMS送信希望の初期値はASWDB(マスタ)にて定義するため、以下の条件でASWDBマスタのオフィステーブルから搭乗者SMS送信選択初期値を取得する。
    this.initialValueSMS();
    // (1.11) リスト定義のデータを用意する。
    this._serviceRequestPaymentInputService.createPhoneCountryInfoList();
    // (1.12) サービシング共通store.ワーニングメッセージリストが存在する場合、当画面にてワーニングメッセージ表示する。
    if (!isEmptyArray(this.servicingCommon.preWarningMessageList)) {
      this.servicingCommon.preWarningMessageList?.forEach((warning) => {
        this._common.alertMessageStoreService.setAlertWarningMessage(warning);
      });
    }

    const flightsByUN = filterFlightsByCondition(this._serviceRequestPaymentInputService.pnr$?.value, [
      { key: 'statusCode', value: FLIGHT_STATUS_CODE.UN, operator: notEqual },
    ]);

    this._serviceRequestPaymentInputService.firstBaggagePassengerInforList =
      this._serviceRequestPaymentInputService.seatPassengerInforList =
      this._serviceRequestPaymentInputService.loungePassengerInforList =
        filterTravelersByCondition(this._serviceRequestPaymentInputService.pnr$?.value, [
          {
            key: 'passengerTypeCode',
            value: PassengerType.INF,
            operator: notEqual,
          },
        ]);
    this._serviceRequestPaymentInputService.mealPassengerInforList =
      this._serviceRequestPaymentInputService.pnr$?.value?.travelers ?? [];
    this._serviceRequestPaymentInputService.firstBaggageBoundInforList = this.getFirstBaggageBoundInforList();
    this._serviceRequestPaymentInputService.loungeFlightInforList = this.getLoungeFlightInforList(flightsByUN);
    this._serviceRequestPaymentInputService.mealFlightInforList = this.getMealFlightInforList(flightsByUN);
    this._serviceRequestPaymentInputService.seatFlightInforList = flightsByUN;
  }

  private initializePaymentMethodDisplayList(): { [key: string]: { value: boolean } } {
    return {
      [PaymentMethodsType.ALIPAY]: { value: true },
      [PaymentMethodsType.UNION_PAY]: { value: true },
      [PaymentMethodsType.CREDIT_CARD]: { value: true },
      [PaymentMethodsType.PAYPAL]: { value: true },
    };
  }

  initPaymentMethod() {
    // (1.6.1) 以下の通りに、支払方法利用可否判定マップを初期化する。以下の通りに、支払方法利用可否判定マップを初期化する。
    let paymentMethodDisplayList = this.initializePaymentMethodDisplayList();

    // (1.6.2) 以下の条件でASWDB(マスタ)のオフィステーブルよりPayPal支払可能フラグを取得する。
    const operationOfficeCode = this._common.aswContextStoreService.aswContextData.pointOfSaleId;
    const currentOffice =
      this._serviceRequestPaymentInputService.serviceRequestPaymentInputMasterState$.value.officeByOffceCodeInfo?.[
        String(operationOfficeCode)
      ];
    // (1.6.3) 以下の通りに、支払方法利用可否判定マップを編集する。
    // (1.6.3.1) ユーザ共通情報.POS国コード ≠"CN"(中国)の場合、key = "AP"(ALIPAY) と"CU"(銀聯)のvalueはfalse(利用不可)に変更する。
    if (this._common.aswContextStoreService.aswContextData.posCountryCode !== 'CN') {
      paymentMethodDisplayList[PaymentMethodsType.ALIPAY].value = false;
      paymentMethodDisplayList[PaymentMethodsType.UNION_PAY].value = false;
    }
    // (1.6.3.2) PayPal支払可能フラグ=falseの場合、key = "PP"(PayPal)のvalueはfalse(利用不可)に変更する。
    if (currentOffice?.[0]?.paypal_available_flag === false) {
      paymentMethodDisplayList[PaymentMethodsType.PAYPAL].value = false;
    }
    paymentMethodDisplayList = { ...this.updatePaymentMethodsForDevice(paymentMethodDisplayList) };

    // (1.6.4) 支払方法選択の初期選択は以下の通りに設定する。
    this._serviceRequestPaymentInputService.paymentMethodDisplayList$.next(paymentMethodDisplayList);
    // (1.6.4.1) 予約基本情報取得API応答.data.paymentMethodをキーとし、支払方法利用可否判定マップから当該valueを取得する。
    const paymentMethodAmc = this._serviceRequestPaymentInputService.amc$.value?.paymentMethod;
    // (1.6.4.2) 当該value = trueの場合、予約基本情報取得API応答.data.paymentMethodの当該支払方法を初期選択とする。
    if (paymentMethodDisplayList[paymentMethodAmc!]) {
      this.selectedPaymentMethod = paymentMethodAmc!;
    } else {
      // (1.6.4.3) 上記以外の場合、支払方法利用可否判定マップの一番目のvalue=trueである支払方法を初期選択とする。
      const paymentMethod = Object.keys(paymentMethodDisplayList).find((key) => paymentMethodDisplayList[key].value);
      this.selectedPaymentMethod = paymentMethod!;
    }
    if (this._serviceRequestPaymentInputService.previousPaymentMethod) {
      this.selectedPaymentMethod = this._serviceRequestPaymentInputService.previousPaymentMethod;
      this._serviceRequestPaymentInputService.previousPaymentMethod = '';
    }

    // Update paymentMethod
    this._serviceRequestPaymentInputService.paymentMethod$.next(this.selectedPaymentMethod);
    // remove redundant form control
    this._serviceRequestPaymentInputService.removeControlsByMethod(this.selectedPaymentMethod);
  }

  updatePaymentMethodsForDevice(paymentMethodDisplayList: { [key: string]: { value: boolean } }): {
    [key: string]: { value: boolean };
  } {
    let updatePaymentMethodDisplayList: { [key: string]: { value: boolean } } = {
      ...paymentMethodDisplayList,
    };
    for (const key in updatePaymentMethodDisplayList) {
      // (1.6.3.3) 当該支払方法利用可否.value = true(利用可能)の場合、
      if (updatePaymentMethodDisplayList[key].value) {
        // (1.6.3.3.1) 以下の条件でASWDB(マスタ)の支払情報テーブルより[PCデバイス]、[SPデバイス]、 [TABデバイス]を取得する。
        const paymentInfo =
          this._serviceRequestPaymentInputService.serviceRequestPaymentInputMasterState$.value.paymentInformation?.find(
            (paymentInformation) => paymentInformation.payment_method === key
          );
        updatePaymentMethodDisplayList = this.updatePaymentMethodForDeviceType(
          updatePaymentMethodDisplayList,
          key,
          paymentInfo
        );
      }
    }
    return updatePaymentMethodDisplayList;
  }

  private updatePaymentMethodForDeviceType(
    paymentMethodDisplayList: { [key: string]: { value: boolean } },
    key: string,
    paymentInfo?: MPaymentInformation
  ) {
    let updatePaymentMethodDisplayList: { [key: string]: { value: boolean } } = {
      ...paymentMethodDisplayList,
    };
    const deviceType = this._common.aswContextStoreService.aswContextData.deviceType;
    const isPc = deviceType === DeviceType.PC;
    const isTb = deviceType === DeviceType.TABLET;
    const isSp = deviceType === DeviceType.SMART_PHONE;
    if (paymentInfo) {
      // (1.6.3.3.2) ユーザ共通情報.端末種別 = "PC"の場合、当該支払方法利用可否.valueはPCデバイスの値に変更する。
      if (isPc) {
        updatePaymentMethodDisplayList[key].value = paymentInfo.available_pc;
      }
      // (1.6.3.3.3) ユーザ共通情報.端末種別 = "TAB"の場合、当該支払方法利用可否.valueはTABデバイスの値に変更する。
      if (isTb) {
        updatePaymentMethodDisplayList[key].value = paymentInfo.available_tab;
      }
      // (1.6.3.3.4) ユーザ共通情報.端末種別 = "SP"の場合、当該支払方法利用可否.valueはSPデバイスの値に変更する。
      if (isSp) {
        updatePaymentMethodDisplayList[key].value = paymentInfo.available_sp;
      }
    }
    return updatePaymentMethodDisplayList;
  }

  preparePaymentDetailsData() {
    // (1.9.1) 変数を作成する。
    // (1.9.1.1) 支払詳細リストを空で作成する。
    const paymentDetailsList: PaymentDetailsData[] = [];
    // (1.9.2) 購入サービス一覧の表示順はASWDB(マスタ)にて定義するため、以下の処理を行う。
    // (1.9.2.1) 以下の条件でASWDBマスタの有料サービス情報テーブルからAncillaryコードを取得する。
    const chargeableLounge =
      this._serviceRequestPaymentInputService.serviceRequestPaymentInputMasterState$.value.chargeableService
        ?.slice()
        .sort((a, b) => a.display_order - b.display_order) ?? [];
    // (1.9.2.2.1)	Ancillaryコード = "SIT-"は「事前座席指定」の情報である。
    const advanceSeatReservation = chargeableLounge.find(
      (item) => item.ancillary_code === CHARGEABLE_LOUNGE_TYPE.ADVANCE_SEAT_RESERVATION
    );
    // (1.9.2.2.2)	Ancillaryコード = "LOUG"は「ラウンジ情報」の情報である。
    const loungeInformation = chargeableLounge.find(
      (item) => item.ancillary_code === CHARGEABLE_LOUNGE_TYPE.LOUNGE_INFORMATIONL
    );
    // (1.9.2.2.3)	Ancillaryコード = "FBAG"は「事前追加手荷物」の情報である。
    const advanceAdditionalBaggage = chargeableLounge.find(
      (item) => item.ancillary_code === CHARGEABLE_LOUNGE_TYPE.ADVANCE_ADDITIONAL_BAGGAGE
    );
    // (1.9.2.2.4)	Ancillaryコード = "MEAL"は「機内食情報」の情報である。
    const inFlightMealInformation = chargeableLounge.find(
      (item) => item.ancillary_code === CHARGEABLE_LOUNGE_TYPE.INFLIGHT_MEAL_INFORMATION
    );
    // (1.9.3) 購入サービスの詳細を用意する。
    const travelersByINF = filterTravelersByCondition(this._serviceRequestPaymentInputService.pnr$?.value, [
      {
        key: 'passengerTypeCode',
        value: PassengerType.INF,
        operator: notEqual,
      },
    ]);
    for (const traveler of travelersByINF) {
      const travelerId = traveler?.id;
      // (1.9.3.1.1) 搭乗者名について
      // (1.9.3.1.1.1) 搭乗者名 = 当該travelers.names[0].title(搭乗者敬称)+ " "(半角スペース)+当該travelers.names[0].firstName(搭乗者名)+ " "(半角スペース)
      // + 当該travelers.names[0].lastName(搭乗者姓)を設定する。
      let passengerName = concatenateTravelerNames(traveler?.names?.[0] ?? {});
      // (1.9.3.1.1.2) 当該travelers.accompanyingTravelerId ≠ ""(空欄)(同伴搭乗者がいる)場合
      let accompanyingName = '';

      if (!isStringEmpty(traveler?.accompanyingTravelerId)) {
        accompanyingName = this.onHandleaccompanyingTraveler(traveler);
      }
      // (1.9.3.1.2) 搭乗者種別 = 当該travelers.passengerTypeCodeを設定する。
      const passengerType = traveler?.passengerTypeCode;
      // (1.9.3.1.3) 購入サービス情報について
      // (1.9.3.1.3.1) 購入サービス情報リストを空で作成する。
      const purchasedServiceInformationList: PurchasedServiceInformationData[] = [];

      // (1.9.3.1.3.2) 事前座席指定について
      this.aboutAdvanceSeatReservation(
        travelerId,
        advanceSeatReservation?.service_name_message_key,
        purchasedServiceInformationList
      );
      // (1.9.3.1.3.3) ラウンジ情報について
      this.aboutLoungeLnformation(
        travelerId,
        loungeInformation?.service_name_message_key,
        purchasedServiceInformationList
      );
      // (1.9.3.1.3.4) 事前追加手荷物について
      this.aboutAdvanceAdditionalBaggage(
        travelerId,
        advanceAdditionalBaggage?.service_name_message_key,
        purchasedServiceInformationList
      );
      // (1.9.3.1.3.5) 機内食情報について
      this.aboutInFlightMealInformation(
        travelerId,
        inFlightMealInformation?.service_name_message_key,
        purchasedServiceInformationList
      );
      // (1.9.3.1.4) 搭乗者名、搭乗者種別、購入サービス情報リストであるレコードを支払詳細リストに追加する。
      paymentDetailsList.push({
        passengerName: passengerName,
        passengerType: passengerType,
        accompanyingName: accompanyingName,
        purchasedServiceInformationList: purchasedServiceInformationList,
      });
    }
    this._serviceRequestPaymentInputService.paymentDetailsList = paymentDetailsList;
  }

  onHandleaccompanyingTraveler(traveler: Traveler) {
    // (1.9.3.1.1.2.1) PNR情報取得API応答.data.travelers[]の中に、id = 当該travelers.accompanyingTravelerIdである同伴搭乗者を取得する。
    const accompanyingTraveler = this._serviceRequestPaymentInputService.pnr$?.value?.travelers?.find(
      (item) => item?.id === traveler?.accompanyingTravelerId
    );
    // (1.9.3.1.1.2.2) 搭乗者名 += <改行> + 同伴搭乗者.names[0].title(搭乗者敬称)+ " "(半角スペース)+同伴搭乗者.names[0].firstName(搭乗者名)
    // + " "(半角スペース) + 同伴搭乗者.names[0].lastName(搭乗者姓)を設定する。
    return !isEmptyObject(accompanyingTraveler) ? concatenateTravelerNames(accompanyingTraveler?.names?.[0]) : '';
  }

  aboutAdvanceSeatReservation(
    travelerId?: string,
    service_name_message_key?: string,
    purchasedServiceInformationList: PurchasedServiceInformationData[] = []
  ) {
    // (1.9.3.1.3.2.1)	購入サービス名 = 事前座席指定のラベルの旨を設定する。
    let purchaseServiceName = service_name_message_key;
    let amountByService: string | number = '';
    // (1.9.3.1.3.2.2) サービシング共通store.事前座席指定.申込操作中かどうか ≠ trueの場合
    if (this.servicingCommon?.seatReservationStatus?.isApplicationProcessed !== true) {
      amountByService = NOTELIGIBLEFORPAYMENT;
    }
    // (1.9.3.1.3.2.3) サービシング共通store.事前座席指定.申込操作中かどうか = trueの場合
    else {
      // (1.9.3.1.3.2.3.1) サービス別金額 = 0を設定する。
      amountByService = 0;

      this.flights?.forEach((flight) => {
        // (1.9.3.1.3.2.3.2) 搭乗者事前座席としてサービシング共通store.事前座席指定.<当該flight.id>.<当該travelers.id> である情報を取得する。
        const flightInfo = this.servicingCommon?.seatReservationStatus?.[String(flight?.id)] as SegmentMap;
        // (1.9.3.1.3.2.3.3) 搭乗者事前座席が存在する場合
        // (1.9.3.1.3.2.3.3.1) サービス別金額 += 搭乗者事前座席.有料サービス金額を設定する。
        amountByService = Number(amountByService) + Number(flightInfo?.[String(travelerId!)]?.paidServiceAmount ?? 0);
      });

      // (1.9.3.1.3.2.3.4) サービス別金額 = 0の場合
      if (amountByService === 0) {
        // (1.9.3.1.3.2.3.4.1) サービス別金額 = 支払対象外である旨を設定する。
        amountByService = NOTELIGIBLEFORPAYMENT;
      }
    }
    // (1.9.3.1.3.2.4) 購入サービス名、サービス別金額 であるレコードを購入サービス情報リストに追加する。
    purchasedServiceInformationList.push({
      purchaseServiceName: purchaseServiceName,
      amountByService: String(amountByService),
    });
  }

  aboutLoungeLnformation(
    travelerId?: string,
    service_name_message_key?: string,
    purchasedServiceInformationList: PurchasedServiceInformationData[] = []
  ) {
    // (1.9.3.1.3.3.1) 購入サービス名 = ラウンジ情報のラベルの旨を設定する。
    const purchaseServiceName = service_name_message_key;
    let amountByService: string | number = '';
    // (1.9.3.1.3.3.2) サービシング共通store.ラウンジ情報.申込操作中かどうか ≠ trueの場合
    if (this.servicingCommon?.chargeableLounge?.isApplicationProcessed !== true) {
      amountByService = NOTELIGIBLEFORPAYMENT;
    }
    // (1.9.3.1.3.3.3) サービシング共通store.ラウンジ情報.申込操作中かどうか = trueの場合
    else {
      // (1.9.3.1.3.3.3.1) サービス別金額 = 0を設定する。
      amountByService = 0;

      this.flights?.forEach((flight) => {
        // (1.9.3.1.3.3.3.2) 搭乗者ラウンジ情報としてサービシング共通store.ラウンジ情報.<当該flight.id>.<当該travelers.id> である情報を取得する。
        const chargeableLoungePassengerApplyInfo = (
          this.servicingCommon?.chargeableLounge?.[flight?.id!] as ChargeableLoungePassengerApplyStatusMap
        )?.[String(travelerId)] as ChargeableLoungePassengerApplyInfo;
        // (1.9.3.1.3.3.3.3) 搭乗者ラウンジ情報が存在する場合
        // (1.9.3.1.3.3.3.3.1) サービス別金額 += 搭乗者ラウンジ情報.有料サービス金額を設定する。
        amountByService = Number(amountByService) + Number(chargeableLoungePassengerApplyInfo?.paidServiceAmount ?? 0);
      });

      // (1.9.3.1.3.3.3.4) サービス別金額 = 0の場合
      if (amountByService === 0) {
        // (1.9.3.1.3.3.3.4.1) サービス別金額 = 支払対象外である旨を設定する。
        amountByService = NOTELIGIBLEFORPAYMENT;
      }
    }
    // (1.9.3.1.3.3.4) 購入サービス名、サービス別金額 であるレコードを購入サービス情報リストに追加する。
    purchasedServiceInformationList.push({
      purchaseServiceName: purchaseServiceName,
      amountByService: String(amountByService),
    });
  }

  aboutAdvanceAdditionalBaggage(
    travelerId?: string,
    service_name_message_key?: string,
    purchasedServiceInformationList: PurchasedServiceInformationData[] = []
  ) {
    // (1.9.3.1.3.4.1) 購入サービス名 = 事前追加手荷物のラベルの旨を設定する。
    const purchaseServiceName = service_name_message_key;
    let amountByService: string | number = '';
    // (1.9.3.1.3.4.2) サービシング共通store.事前追加手荷物.申込操作中かどうか ≠trueの場合
    if (this.servicingCommon?.firstBaggage?.isApplicationProcessed !== true) {
      amountByService = NOTELIGIBLEFORPAYMENT;
    }
    // (1.9.3.1.3.4.3) サービシング共通store.事前追加手荷物.申込操作中かどうか = trueの場合
    else {
      // (1.9.3.1.3.4.3.1) サービス別金額 = 0を設定する。
      amountByService = 0;
      const bounds = this._serviceRequestPaymentInputService?.pnr$.value?.air?.bounds;
      bounds?.forEach((bound) => {
        // (1.9.3.1.3.4.3.2) 搭乗者手荷物としてサービシング共通store.事前追加手荷物.<当該bound.airBoundId>.<当該travelers.id> である情報を取得する。
        const firstBaggagePassengerApplyInfo = (
          this.servicingCommon?.firstBaggage?.[bound?.airBoundId!] as FirstBaggageBoundMap
        )?.[String(travelerId)] as FirstBaggagePassengerApplyInfo;
        // (1.9.3.1.3.4.3.3) 搭乗者手荷物が存在する場合
        // (1.9.3.1.3.4.3.3.1) サービス別金額 += 搭乗者手荷物.有料サービス金額を設定する。
        amountByService = Number(amountByService) + Number(firstBaggagePassengerApplyInfo?.paidServiceAmount ?? 0);
      });
      // (1.9.3.1.3.3.3.4) サービス別金額 = 0の場合
      if (amountByService === 0) {
        // (1.9.3.1.3.3.3.4.1) サービス別金額 = 支払対象外である旨を設定する。
        amountByService = NOTELIGIBLEFORPAYMENT;
      }
    }
    // (1.9.3.1.3.4.4) 購入サービス名、サービス別金額 であるレコードを購入サービス情報リストに追加する。
    purchasedServiceInformationList.push({
      purchaseServiceName: purchaseServiceName,
      amountByService: String(amountByService),
    });
  }

  aboutInFlightMealInformation(
    travelerId?: string,
    service_name_message_key?: string,
    purchasedServiceInformationList: PurchasedServiceInformationData[] = []
  ) {
    // (1.9.3.1.3.5.1) 購入サービス名 = 機内食情報のラベルの旨を設定する。
    const purchaseServiceName = service_name_message_key;
    let amountByService: string | number = '';
    // (1.9.3.1.3.5.2) サービシング共通store.機内食情報.申込操作中かどうか ≠true の場合
    if (this.servicingCommon?.meal?.isApplicationProcessed !== true) {
      amountByService = NOTELIGIBLEFORPAYMENT;
    }
    // (1.9.3.1.3.5.3) サービシング共通store.機内食情報.申込操作中かどうか = trueの場合
    else {
      // (1.9.3.1.3.5.3.1) サービス別金額 = 0を設定する。
      amountByService = 0;

      this.flights?.forEach((flight) => {
        // (1.9.3.1.3.5.3.2) 搭乗者機内食情報としてサービシング共通store.機内食情報.<当該flight.id>.<当該travelers.id> である情報を取得する。
        const mealPassengerApplyInfo = (
          this.servicingCommon?.meal?.[String(flight?.id)] as MealPassengerApplyStatusMap
        )?.[String(travelerId)] as MealPassengerApplyInfo;
        // (1.9.3.1.3.5.3.3) 搭乗者機内食情報が存在する場合
        // (1.9.3.1.3.5.3.3.1) サービス別金額 += 搭乗者機内食情報.有料サービス金額を設定する。
        amountByService = Number(amountByService) + Number(mealPassengerApplyInfo?.paidServiceAmount ?? 0);
      });

      // (1.9.3.1.3.3.5.4) サービス別金額 = 0の場合
      if (amountByService === 0) {
        // (1.9.3.1.3.3.5.4.1) サービス別金額 = 支払対象外である旨を設定する。
        amountByService = NOTELIGIBLEFORPAYMENT;
      }
    }
    // (1.9.3.1.3.3.5) 購入サービス名、サービス別金額 であるレコードを購入サービス情報リストに追加する。
    purchasedServiceInformationList.push({
      purchaseServiceName: purchaseServiceName,
      amountByService: String(amountByService),
    });
  }
  // (1.10) SMS送信希望の初期値はASWDB(マスタ)にて定義するため、以下の条件でASWDBマスタのオフィステーブルから「搭乗者SMS送信選択初期値」を取得する。
  initialValueSMS() {
    const operationOfficeCode = this._common.aswContextStoreService.aswContextData.pointOfSaleId;
    const currentOffice =
      this._serviceRequestPaymentInputService.serviceRequestPaymentInputMasterState$.value.officeByOffceCodeInfo?.[
        String(operationOfficeCode)
      ];

    this._serviceRequestPaymentInputService.smsTransmissionPreference = currentOffice?.[0]?.sms_send_select_initial;
  }

  getFirstBaggageBoundInforList = () => {
    let bounds: Bound[] = [];
    this._serviceRequestPaymentInputService.pnr$?.value.air?.bounds?.forEach((bound) => {
      const firstBaggage = (
        this._serviceRequestPaymentInputService.pnr$?.value.services?.baggage?.firstBaggage as FirstBaggagePnr
      )?.[bound?.airBoundId!];
      const isMatchStatus = this._serviceRequestPaymentInputService.pnr$?.value.travelers?.some((traveler) => {
        const firstBaggagePassengerMap = firstBaggage?.[String(traveler.id)] as FirstBaggagePassengerMap;
        return (
          firstBaggage?.isAvailable === true ||
          (!isStringEmpty(firstBaggagePassengerMap?.serviceStatus) &&
            firstBaggagePassengerMap?.serviceStatus !== FirstBaggagePassengerMap.ServiceStatusEnum.Cancelled &&
            firstBaggagePassengerMap?.serviceStatus !== FirstBaggagePassengerMap.ServiceStatusEnum.NotRequested &&
            firstBaggagePassengerMap?.serviceStatus !== FirstBaggagePassengerMap.ServiceStatusEnum.Unavailable)
        );
      });

      if (isMatchStatus) {
        bounds.push(bound);
      }
    });
    return bounds;
  };

  getLoungeFlightInforList = (flightsByUN?: Array<Type1>): Array<Type1> => {
    let flights: Type1[] = [];
    if (this._serviceRequestPaymentInputService.pnr$?.value.orderEligibilities?.chargeableLounge?.isEligible === true) {
      const flightsByUNs = flightsByUN ?? [];
      for (const flight of flightsByUNs) {
        const lounge = (this._serviceRequestPaymentInputService.pnr$?.value.services?.lounge as Lounge)?.[flight?.id!];
        if (lounge?.isAvailable === true) {
          flights.push(flight);
        }
      }
    }
    return flights;
  };

  getMealFlightInforList = (flightsByUN?: Array<Type1>): Array<Type1> => {
    let flights: Type1[] = [];
    const flightsByUNs = flightsByUN ?? [];
    for (const flight of flightsByUNs) {
      const meal = (this._serviceRequestPaymentInputService.pnr$?.value.services?.meal as Meal)?.[flight?.id!];
      /** 3.5.3. 当該セグメント情報.statusCode≠”UN” かつ PNR情報取得API応答.data.services.meal.<当該セグメント情報.セグメントID>.isAvailable=true(申込可)場合、機内食セグメント情報リストに当該セグメント情報を追加する。 */
      if (meal?.isAvailable === true) {
        flights.push(flight);
      }
    }
    return flights;
  };

  destroy(): void {
    this._servicingCommonStoreService.updateServicingCommon({
      previousPageIdentifier: PREVIOUS_PAGE_IDENTIFIER.SERVICE_PAYMENT_INFORMATION_INPUT,
    });
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
  }

  reload() {
    /* Override abstract reload of base class*/
  }
}
